var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45463 35.02L31.4482 9.02637L25.9939 3.572L0.00025707 29.5656L5.45463 35.02Z",
    fill: "url(#paint0_linear_2020_1197)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45463 35.02L31.4482 9.02637L25.9939 3.572L0.00025707 29.5656L5.45463 35.02Z",
    fill: "url(#paint1_linear_2020_1197)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50713 27.3219V13.9314H0.0078125V27.3219C0.0078125 31.4638 3.36524 34.8211 7.50713 34.8211H20.8976V27.3219H7.50713ZM26.3502 0.979492H7.50713C3.36524 0.979492 0.0078125 4.33686 0.0078125 8.47875V8.48849H26.3502V34.8211C30.4921 34.8211 33.8495 31.4638 33.8495 27.3219V8.47875C33.8495 4.33686 30.4921 0.979492 26.3502 0.979492Z",
    fill: "#36D66B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2020_1197",
    x1: 1.69239,
    y1: 31.509,
    x2: 29.7549,
    y2: 7.07675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D6DAD7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#616F64",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B3021",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071E0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2020_1197",
    x1: 1.69293,
    y1: 31.512,
    x2: 29.7506,
    y2: 7.07974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#071E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#134E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#26994C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2DB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32C763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#35D269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D66B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoIcon);
export default __webpack_public_path__ + "static/media/brandLogoIcon.1000e7515fe5611be79d6a61dbc3d509.svg";
export { ForwardRef as ReactComponent };